<template>
  <v-container fluid>
    <div v-if="banner.id">
      <customer-context-prompt :resource="banner"/>
      <h2>{{ $t('edit_banner') }}</h2>

      <banner-form :banner="banner"></banner-form>
    </div>
  </v-container>

</template>

<script>
import CustomerContextPrompt from '@/components/shared/CustomerContextPrompt'
import BannerForm from '@/components/banner/BannerForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  components: { CustomerContextPrompt, BannerForm },
  mixins: [BrowserUtilitiesMixin],
  data () {
    return {
      banner: {}
    }
  },
  methods: {
    fetchModel () {
      this.$orm('Banner')
        .find(this.$route.params.id)
        .then((banner) => {
          this.banner = banner
        })
        .catch(error => {
          if (error) {
            this.renderErrorModal(error)

            // Re-throw the error so that it shows up in the js console and is
            // reported to our error handler end-point
            throw (error)
          }
        })
    }
  },
  created () {
    this.fetchModel()
  },
  mounted () {
    this.updateBrowserTitle(this.$t('edit_banner'))
  }
}
</script>
